import { render, staticRenderFns } from "./NotificationsHeader.vue?vue&type=template&id=e2854afa&scoped=true"
import script from "./NotificationsHeader.vue?vue&type=script&lang=js"
export * from "./NotificationsHeader.vue?vue&type=script&lang=js"
import style0 from "./NotificationsHeader.vue?vue&type=style&index=0&id=e2854afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2854afa",
  null
  
)

export default component.exports